import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './component/home/home.component';
import { LoginCallbackComponent } from './component/login-callback/login-callback.component';
import { AcessosUsuariosComponent } from './component/menu/admin/acessos-usuarios/acessos-usuarios.component';
import { SolicitacaoEnvioComponent } from './component/menu/renavam/solicitacao-envio/solicitacao-envio.component';
import { RenaveComponent } from './component/menu/renave/renave.component';
import { AuthGuard } from './auth/auth.guard';
import { CodigosComponent } from './component/menu/renavam/codigos/codigos.component';
import { NotificacaoComponent } from './component/menu/renavam/notificacao/notificacao.component';
import { MarcaModeloComponent } from './component/menu/renavam/marca-modelo/marca-modelo.component';
import { RetornoPreCadComponent } from './component/menu/renavam/retorno-precad/retorno-precad.component';
import { MsalGuard } from '@azure/msal-angular';
import { AppRoles } from './auth/interfaces';

const routes: Routes = [
  { path: '', redirectTo: '/Home', pathMatch: 'full' },
  { path: 'Home', component: HomeComponent, title: 'RENA', canActivate: [MsalGuard, AuthGuard],
    data: { roles: [AppRoles.isAdmin, AppRoles.isRenavam, AppRoles.isRenave] }},
  // { path: 'login-callback', component: LoginCallbackComponent, title: 'login-callback' },
  // { path: 'Admin/AcessosUsuarios', component: AcessosUsuariosComponent, title: 'ADMIN - Usuários', canActivate: [MsalGuard, AuthGuard],
  //   data: { roles: [AppRoles.isAdmin] }},
  { path: 'Renavam/Codigos', component: CodigosComponent, title: 'RENAVAM - Códigos', canActivate: [MsalGuard, AuthGuard],
    data: { roles: [AppRoles.isRenavam] } },
  { path: 'Renavam/MarcaModelo', component: MarcaModeloComponent, title: 'RENAVAM - Modelos', canActivate: [MsalGuard, AuthGuard],
    data: { roles: [AppRoles.isRenavam] } },
  { path: 'Renavam/Notificacao', component: NotificacaoComponent, title: 'RENAVAM - Notificações', canActivate: [MsalGuard, AuthGuard],
    data: { roles: [AppRoles.isRenavam] } },
  { path: 'Renavam/RetornoPreCadastro', component: RetornoPreCadComponent, title: 'RENAVAM - Retorno Pré-Cadastro', canActivate: [MsalGuard, AuthGuard],
    data: { roles: [AppRoles.isRenavam] } },
  { path: 'Renavam/SolicitacaoEnvio', component: SolicitacaoEnvioComponent, title: 'RENAVAM - Solicitação de Envio', canActivate: [MsalGuard, AuthGuard],
    data: { roles: [AppRoles.isRenavam] } },
  { path: 'Renave', component: RenaveComponent, title: 'RENAVE', canActivate: [MsalGuard, AuthGuard],
    data: { roles: [AppRoles.isRenave] } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {}
